(function () {
    var MOBILE_QUERY = '(max-width: 749px)';

    function syncCtScroll(table) {
        var bodyTrack = table.querySelector('[data-ct-scroll-wrapper]');
        var headerMirror = table.querySelector('[data-ct-header-mirror]');
        var imagesTrack = table.querySelector('[data-ct-images-track]');
        if (!bodyTrack) return;

        var imagesRow = imagesTrack ? imagesTrack.querySelector('.ct-header-row') : null;
        var syncing = false;

        function mirrorScroll(scrollLeft) {
            if (syncing) return;
            syncing = true;

            if (headerMirror) {
                headerMirror.scrollLeft = scrollLeft;
            }

            if (imagesRow && window.matchMedia(MOBILE_QUERY).matches) {
                imagesRow.style.transform = 'translateX(-' + scrollLeft + 'px)';
            } else if (imagesRow) {
                imagesRow.style.transform = '';
            }

            syncing = false;
        }

        bodyTrack.addEventListener(
            'scroll',
            function () {
                mirrorScroll(bodyTrack.scrollLeft);
            },
            { passive: true }
        );

        mirrorScroll(bodyTrack.scrollLeft);
    }

    function initCtSwatchFallbacks() {
        document.querySelectorAll('.ct-param-swatch[data-swatch-fallback]').forEach(function (el) {
            var primaryUrl = el.getAttribute('data-swatch-primary');
            var fallbackUrl = el.getAttribute('data-swatch-fallback');
            var hexColor = el.getAttribute('data-swatch-color');

            function applyHexFallback() {
                el.style.backgroundImage = 'none';
                if (hexColor) {
                    el.style.backgroundColor = hexColor;
                } else {
                    el.classList.add('ct-param-swatch--hidden');
                }
            }

            function tryFallbackUrl() {
                if (!fallbackUrl || fallbackUrl === primaryUrl) {
                    applyHexFallback();
                    return;
                }

                var fallbackImg = new Image();
                fallbackImg.onload = function () {
                    el.style.backgroundImage = "url('" + fallbackUrl + "')";
                };
                fallbackImg.onerror = applyHexFallback;
                fallbackImg.src = fallbackUrl;
            }

            if (!primaryUrl) {
                applyHexFallback();
                return;
            }

            var primaryImg = new Image();
            primaryImg.onerror = tryFallbackUrl;
            primaryImg.src = primaryUrl;
        });
    }

    function initComparisonTables() {
        document.querySelectorAll('[data-ct-table]').forEach(syncCtScroll);
        initCtSwatchFallbacks();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initComparisonTables);
    } else {
        initComparisonTables();
    }

    document.addEventListener('shopify:section:load', initComparisonTables);
})();
